import React from "react";

import { hasClassPrefix } from "../../utils";

interface textProps {
  label: string;
  styleVal?: string;
  mandatory?: boolean;
  icon?: React.ReactNode;
}

const Textlabel: React.FC<textProps> = ({
  label,
  styleVal = "",
  mandatory,
  icon,
}) => {
  return (
    <label
      className={[
        "whitespace-nowrap flex items-center",
        hasClassPrefix(styleVal, "w-") ? "" : "w-fit",
        hasClassPrefix(styleVal, "px-") ? "" : "px-5",
        styleVal || "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label} {mandatory && <span className="ml-1 text-red-600">*</span>}
      {icon}
    </label>
  );
};

export default Textlabel;
